import request from '../request'

export default {
  getEmergencias: () => {
    return request.get('emergencias')
  },

  getEmergenciasAll: () => {
    return request.get('emergencias/all')
  },

  getEmergenciaByID: (emergenciaId) => {
    return request.get(`emergencias/${emergenciaId}`)
  },

  addPlanOperaciones: (data) => {
    return request.post('plan_operaciones', data)
  },

  editPlanOperaciones: (data) => {
    return request.put(`plan_operaciones/${data.ID_PLAN_OPERACIONES}`, data)
  },
  deletePlanOperaciones: (data) => {
    return request.delete(`plan_operaciones/${data.ID_PLAN_OPERACIONES}`)
  },

  addSector(data) {
    return request.post(`sector`, data)
  },

  updateSector(data) {
    return request.put(`sector/${data.ID_SECTOR}`, data)
  },

  cambiarOcultoEmergencia(data) {
    return request.put(`emergencia/${data.ID_EMERGENCIA}/cambiarOcultoEmergencia`, data)
  },

  deleteSector(idSector) {
    return request.delete(`sector/${idSector}`)
  },

  updateEmergencia: (data) => {
    return request.put('/emergencias', data)
  },

  deleteEmergencia: (idEmergencia) => {
    return request.put(`deleteEmergencia/${idEmergencia}`)
  },

  addPerimetro: (data) => {
    return request.post('perimetro', data)
  },

  addImportedPerimetro(data) {
    return request.post('perimetro/addImportedPerimetro', data)
  },

  editPerimetro: (data) => {
    return request.put(`perimetro/${data.ID_PERIMETRO}`, data)
  },

  deletePerimetro: (data) => {
    return request.delete(`perimetro/${data.ID_PERIMETRO}`)
  },

  addEstadoEmergencia: (data) => {
    return request.post('/emergencia_estado', data)
  },

  updateEstadoEmergencia: (data) => {
    return request.put('/emergencia_estado', data)
  },

  deleteEstadoEmergencia: (data) => {
    return request.delete('emergencia_estado', { data })
  },

  crearEmergencia: (data) => {
    return request.post('/emergencias', data)
  },

  addRecursosEmergencia: (data) => {
    return request.post('recurso_sector', data)
  },

  editRecursoEmergencia: (data) => {
    return request.put('recurso_sector', data)
  },
  updateRecursoSector: (data) => {
    return request.put(`recurso_sector/${data.idRecursoSector}`, { newSectorId: data.newSectorId, oldSectorId: data.oldSectorId })
  },
  deleteRecursoEmergencia: (idRecursoSector) => {
    return request.delete(`recurso_sector/${idRecursoSector}`)
  },

  getTiposEmergenciaNivel() {
    return request.get('tipo_emergencia_nivel');
  },

  addNivelEmergencia(data) {
    return request.post('emergencia_nivel', data)
  },

  editNivelEmergencia(data) {
    return request.put('emergencia_nivel', data)
  },

  getEmergenciasTipo() {
    return request.get('/emergenciasTipo')
  },

  getEmergenciaEstadoTipo() {
    return request.get('/emergencia_estado_tipo')
  },

  addDirectorExtincion: (data) => {
    return request.post('director_extincion', data)
  },

  editDirectorExtincion: (data) => {
    return request.put(`director_extincion/${data.ID_DIRECTOR_EXTINCION}`, data)
  },

  editDirectorPrincipal: (data) => {
    return request.put(`director_extincion/principal/${data.ID_DIRECTOR_EXTINCION}`, data)
  },

  getIncidenteLog: (idEmergencia) => {
    return request.get(`emergencia/${idEmergencia}/historico_incidente_log`);
  },

  getHistoricoDespachoMedios: (idEmergencia, recursos, recursoEstadoTipo) => {
    return request.post(
      `emergencia/${idEmergencia}/historico_despacho_medios`,
      { recursos, recursoEstadoTipo },
      { responseType: 'blob' }
    );
  },

  getCanalesComunicacion: () => {
    return request.get('canales_comunicacion')
  }
}
